<div>
    <header class="page-heading">
        <div class="container">
            <h1>404 Not Found</h1>
            <p>The document you are trying to view either does not exist or has been moved.</p>
        </div>
    </header>
</div>


// WEBPACK FOOTER //
// ./src/app/components/not-found/not-found.component.html